module.exports = __webpack_public_path__ + "static/media/rectangle-wide.3dd8e204.svg";